import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 56953ABE-D834-4DC6-A44B-87A3BF1181BA
 * name arrow-collapse-horizontal
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-collapse-horizontal.svg
 * tags
 * - Arrow 
 */
export const ArrowCollapseHorizontalIcon = createSvgIcon(<><path d="M13,20V4H15.03V20H13M10,20V4H12.03V20H10M5,8L9.03,12L5,16V13H2V11H5V8M20,16L16,12L20,8V11H23V13H20V16Z" /></>, 'ArrowCollapseHorizontalIcon');
export default ArrowCollapseHorizontalIcon